
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class TableKpiItem extends Vue {
  @Prop({ required: false, default: '' })
  name: string

  @Prop({ required: true, default: 0 })
  amount: number

  @Prop({ required: true, default: 0 })
  total: number

  @Prop({ required: false, default: false })
  amountToCompare: number

  @Prop({ required: false, default: false })
  includeTotal: boolean

  @Prop({ required: false, default: '' })
  suffix: string

  @Prop({ required: false, default: 'blue' })
  color: string

  @Prop({ required: false, default: false })
  hidePercent: boolean

  average = 0
  ranking = 0
  percentAnimOver = false;

  mounted () {
    this.calc()
  }

  calc () {
    this.average = this.total ? this.amount / this.total * 100 : 0
    this.ranking = this.amount - this.amountToCompare
  }

  get formatttedAverage () {
    return this.average.toFixed(1)
  }

  @Watch('total')
  watchTotal () {
    this.calc()
  }

  @Watch('amount')
  watchAmount () {
    this.calc()
  }

  @Watch('amountToCompare')
  watchAmountToCompare () {
    this.calc()
  }
}
